import { gsap } from 'gsap'
import { InertiaPlugin } from 'gsap/InertiaPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default defineNuxtPlugin(() => {
	if (import.meta.client) {
		gsap.registerPlugin(ScrollTrigger, InertiaPlugin)

		// if (process.client) {
		// 	gsap.registerPlugin(Draggable);

		// }
		ScrollTrigger.config({
			autoRefreshEvents: 'DOMContentLoaded,load,resize',
		})
	}

	return {
		provide: {
			gsap,
			ScrollTrigger,
			InertiaPlugin,
		},
	}
})
